var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCellsCellSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 392.598 392.598",
    style: {
      enableBackground: "new 0 0 392.598 392.598"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56ACE0"
    },
    d: "M224.517,92.962c19.653,0,35.556-15.968,35.556-35.556c0-19.653-15.968-35.556-35.556-35.556 C136.469,21.786,64.711,93.479,64.711,181.657c0,19.653,15.968,35.556,35.556,35.556c19.653,0,35.556-15.968,35.556-35.556 C135.822,132.719,175.644,92.962,224.517,92.962z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M224.517,0C124.38,0,42.861,81.519,42.861,181.657c0,31.612,25.729,57.406,57.406,57.406 c31.612,0,57.406-25.729,57.406-57.406c0-36.848,29.996-66.909,66.909-66.909c31.677,0,57.406-25.729,57.406-57.406 C281.923,25.729,256.194,0,224.517,0z M100.267,217.212c-19.653,0-35.556-15.968-35.556-35.556 c0-88.178,71.693-159.871,159.871-159.871c19.653,0,35.556,15.968,35.556,35.556c0,19.653-15.968,35.556-35.556,35.556 c-48.937,0-88.695,39.822-88.695,88.695C135.822,201.309,119.919,217.212,100.267,217.212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M179.329,68.073c1.939-2.133,5.236-3.168,8.145-2.457c5.818,1.552,11.83-1.939,13.317-7.822 c1.552-5.818-1.939-11.83-7.822-13.317c-10.731-2.844-22.497,0.711-29.931,9.051c-4.008,4.461-3.62,11.378,0.84,15.386 C168.404,72.986,175.515,72.404,179.329,68.073z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M160.194,82.036c-3.814-4.719-10.602-5.495-15.321-1.681c-4.655,3.685-10.925,5.56-16.873,5.042 c-6.012-0.646-11.313,3.879-11.895,9.826c-0.517,6.012,3.879,11.313,9.826,11.895c12.671,0.84,23.402-2.521,32.453-9.762 C163.168,93.543,163.943,86.756,160.194,82.036z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M231.111,76.024l5.43-3.879c4.848-3.491,6.012-10.279,2.521-15.192 c-3.491-4.978-10.279-6.012-15.192-2.521l-5.43,3.879c-4.848,3.491-6.012,10.279-2.521,15.192 C220.703,80.291,228.654,77.834,231.111,76.024z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M107.184,167.628c-6.012,0-10.925,4.848-10.925,10.925v11.766c0,6.012,4.848,10.925,10.925,10.925 c6.077,0,10.925-4.848,10.925-10.925v-11.766C118.044,172.477,113.196,167.628,107.184,167.628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M109.317,142.028c5.107-3.168,6.659-9.891,3.491-14.998c-3.168-5.107-9.891-6.659-14.998-3.491 l-9.956,6.206c-5.107,3.168-6.659,9.891-3.491,14.998c3.168,5.107,9.891,6.659,14.998,3.491L109.317,142.028z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC10D"
    },
    d: "M292.396,175.321c-19.652,0-35.556,15.968-35.556,35.556c0,48.937-39.822,88.695-88.695,88.695 c-19.653,0-35.556,15.968-35.556,35.556c0,19.653,15.968,35.556,35.556,35.556c88.178,0,159.871-71.693,159.871-159.871 C327.951,191.224,311.984,175.321,292.396,175.321z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M292.396,153.471c-31.612,0-57.406,25.729-57.406,57.406c0,36.848-29.996,66.909-66.909,66.909 c-31.677,0-57.406,25.729-57.406,57.406c0,31.612,25.729,57.406,57.406,57.406c100.137,0,181.657-81.519,181.657-181.657 C349.802,179.265,324.008,153.471,292.396,153.471z M168.145,370.747c-19.653,0-35.556-15.968-35.556-35.556 c0-19.653,15.968-35.556,35.556-35.556c48.937,0,88.695-39.822,88.695-88.695c0-19.653,15.968-35.556,35.556-35.556 c19.653,0,35.556,15.968,35.556,35.556C327.951,299.055,256.194,370.747,168.145,370.747z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M213.333,324.461c-1.939,2.133-5.236,3.168-8.145,2.457c-5.818-1.552-11.83,1.939-13.317,7.822 c-1.552,5.818,1.939,11.83,7.822,13.317c10.731,2.844,22.497-0.711,29.931-9.051c4.008-4.461,3.62-11.378-0.84-15.386 C224.259,319.547,217.147,320.129,213.333,324.461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M266.667,285.414c-12.671-0.84-23.402,2.521-32.453,9.762c-4.719,3.814-5.495,10.667-1.681,15.321 c3.814,4.719,10.602,5.495,15.321,1.681c4.655-3.685,10.925-5.56,16.873-5.042c6.012,0.646,11.313-3.879,11.895-9.826 C277.01,291.297,272.614,285.996,266.667,285.414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M176.679,319.03c-3.943-5.107-9.18-6.982-15.192-2.521l-5.43,3.879 c-4.848,3.491-6.012,10.279-2.521,15.192c3.491,4.913,10.279,6.012,15.192,2.521l5.43-3.879 C179.071,330.796,180.234,324.008,176.679,319.03z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M296.404,214.044v-11.766c0-6.012-4.848-10.925-10.925-10.925c-6.012,0-10.925,4.848-10.925,10.925 v11.766c0,6.012,4.848,10.925,10.925,10.925C291.555,224.97,296.404,220.057,296.404,214.044z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M293.301,244.234l-9.956,6.206c-5.107,3.168-6.659,9.891-3.491,14.998 c3.168,5.107,9.891,6.659,14.998,3.491l9.956-6.206c5.107-3.168,6.659-9.891,3.491-14.998 C305.196,242.618,298.473,241.067,293.301,244.234z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellsCellSvgrepoCom);
export default __webpack_public_path__ + "static/media/cells-cell-svgrepo-com.432de32484f0bd4f0dbad92dc626dbf9.svg";
export { ForwardRef as ReactComponent };